export function dataToProductBadges(data: any[]) {
  if (!data || !Array.isArray(data)) return []

  return data.map((badge: any) => ({
    id: badge['id'],
    name: badge['badge_name'] || '-',
    displayName: badge['tag_label'] || '-',
    productCount: badge['total_product_count'] || 0,
    status: badge['is_active'] === true ? 'active' : 'inactive',
    createdAt: badge['created_at'],
    updatedAt: badge['updated_at'],
  }))
}
